module.exports = __webpack_public_path__ + "img/18.fd9bcd6.jpg";